import { Controller } from "@hotwired/stimulus"

// Simple controller for dismissable notices with optional auto-dismiss
// Connects to data-controller="dismissable"
export default class extends Controller {
  static values = {
    autoDismiss: { type: Number, default: 0 } // milliseconds, 0 = no auto-dismiss
  }

  connect() {
    if (this.autoDismissValue > 0) {
      this.dismissTimer = setTimeout(() => {
        this.dismiss()
      }, this.autoDismissValue)
    }
  }

  disconnect() {
    if (this.dismissTimer) {
      clearTimeout(this.dismissTimer)
    }
  }

  dismiss() {
    // Fade out animation
    this.element.style.transition = "opacity 0.3s ease-out"
    this.element.style.opacity = "0"
    
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}
